import axios from 'axios'
import Cookies from 'universal-cookie'

import { TASK_V2_GETINFO, TOKEN_LEGAL365, TASK_V2_ADDSUBTASK, TASK_V2_GETSUBTASK, 
    TASK_V2_GETACCIONS, TASK_V2_GETDOCUMENTS, TASK_V2_CREATETEMPLATE, TASK_V2_GETTEMPLATE, 
    TASK_V2_GET_WORKFLOW, TASK_V2_UPDATETEMPLATE,TASK_V2_GETTRIBUNALES, 
    TASK_V2_GET_USERS_CHARGE, LEGAL_GET_ALL_USERS} from '../config.js'

import { CleanJsonData, ClearCookies } from '../Utilities/Utilities.js'
import { Alert } from 'react-bootstrap'

//const
const data = {
    getInfo: { success: false, message: '', status: 0 },
    gruposServicios: [],
    listaAcciones: { success: false, message: '', list: [], status: 0 },
    subTasks: { success: false, message: '', listSubTask: [], status: 0 },
    newSubTask: { success: false, message: '', task: {}, status: 0 },
    documents: { success: false, message: '', list: [], status: 0 },
    template: {success: false, message: '', data:{
        groupId: 0,
        serviceId: 0,
        listOfTasks: [
            {
                orden: 0,
                nomencltureId: 0,
                descripcion: '',
                subTareas: [
                    {
                        orden: 0,
                        idSubTask: 0,
                        titulo: '',
                        descripcion: '',
                        acciones: [
                            {
                                id: 0,
                                dias: 0,
                                documento: 0,
                                subTarea: 0,
                                nomenclatura: 0
                            }
                        ],
                        '': [
                            0
                        ]
                    }
                ]
            }
        ]
    } ,status:0},
    templateCreado: {success: false, message: '', data:{} ,status:0},
    usersCharge: {success: false, message: '', data:{} ,status:0},
    usersLegal: {success: false, message: '', data:{} ,status:0},
    tribunales: {success: false, message: '', data:[] ,status:0},
}

const GET_INFO = 'GET_INFO'
const GET_GRUPO_SERVICIO = 'GET_GRUPO_SERVICIO'
const GET_LISTA_ACCIONES = 'GET_LISTA_ACCIONES'
const GET_LISTA_SUB_TASK = 'GET_LISTA_SUB_TASK'
const GET_LISTA_DOCUMENTS = 'GET_LISTA_DOCUMENTS'
const ADD_SUB_TASK = 'ADD_SUB_TASK'
const CREATE_MEW_TEMPLATE = 'CREATE_MEW_TEMPLATE'
const GET_TEMPLATE = 'GET_TEMPLATE'
const GET_USERS_CHARGE = 'GET_USERS_CHARGE'
const GET_LEGAL_ALL_USERS ='GET_LEGAL_ALL_USERS'
const GET_TRIBUNALES ='GET_TRIBUNALES'


// reducer
export default function tareasV2Reducer(state = data, action) {
    switch (action.type) {
        case GET_INFO:
            return { ...state, getInfo: action.payload }
        case GET_GRUPO_SERVICIO:
            return { ...state, gruposServicios: action.payload }
        case GET_LISTA_ACCIONES:
            return { ...state, listaAcciones: action.payload }
        case GET_LISTA_SUB_TASK:
            return { ...state, subTasks: action.payload }
        case GET_LISTA_DOCUMENTS:
            return { ...state, documents: action.payload }
        case ADD_SUB_TASK:
            return { ...state, newSubTask: action.payload }
        case CREATE_MEW_TEMPLATE:
            return { ...state, templateCreado: action.payload }
        case GET_TEMPLATE:
            return { ...state, template: action.payload }
        case GET_USERS_CHARGE:
            return { ...state, usersCharge: action.payload }
        case GET_LEGAL_ALL_USERS:
            return { ...state, usersLegal: action.payload }
        case GET_TRIBUNALES:
            return { ...state, tribunales: action.payload }
        default:
            return state
    }
}

export const GetTribunales = () => async (dispatch, getState) => {
    const cookies = new Cookies()
    dispatch({
        type: GET_TRIBUNALES,
        payload: { success: false, message: "Buscando Información de Tareas, espere...", data:[], status: 1 }
    })

    try {
        //const RES = await axios.get(TASK_V2_GETINFO)
        const RES = await axios.get(TASK_V2_GETTRIBUNALES, { headers: { 'Authorization': `Bearer `+TOKEN_LEGAL365 } })

        if (RES.status === 200) {
            dispatch({
                type: GET_TRIBUNALES,
                payload: { success: true, message: "Información encontrada, espere...", data:RES.data, status: 2 }
            })
        }
        else {
            dispatch({
                type: GET_TRIBUNALES,
                payload: { success: true, message: "Error al buscar la informacion res:" + RES.status, data:[], status: 3 }
            })
        }
    } catch (error) {
        dispatch({
            type: GET_TRIBUNALES,
            payload: { success: true, message: "Error al buscar la informacion res:" + error.response.status, data:[], status: 3 }
        })
    } 
}

export const GetInfo = () => async (dispatch, getState) => {
    const cookies = new Cookies()
    dispatch({
        type: GET_INFO,
        payload: { success: false, message: "Buscando Información de Tareas, espere...", status: 1 }
    })

    try {
        //const RES = await axios.get(TASK_V2_GETINFO)
        const RES = await axios.get(TASK_V2_GETINFO, { headers: { 'Authorization': `Bearer `+TOKEN_LEGAL365 } })

        if (RES.status === 200) {
            const data = RES.data

            dispatch({
                type: GET_INFO,
                payload: { success: true, message: "Información encontrada, espere...", status: 2 }
            })

            dispatch({
                type: GET_GRUPO_SERVICIO,
                payload: data.gruposServicios
            })
        }
        else {
            dispatch({
                type: GET_INFO,
                payload: { success: true, message: "Error al buscar la informacion res:" + RES.status, status: 3 }
            })
        }
    } catch (error) {
        dispatch({
            type: GET_INFO,
            payload: { success: true, message: "Error al buscar la informacion res:" + error.response.status, status: 3 }
        })
    }
}

export const AddSubTask = (DATA) => async (dispatch, getState) => {
    const cookies = new Cookies()
    dispatch({
        type: ADD_SUB_TASK,
        payload: { success: false, message: "Creando Tareas, espere...", status: 1, task: {} }
    })

    try {
        const RES = await axios.post(TASK_V2_ADDSUBTASK, DATA, { headers: { 'Authorization': `Bearer `+TOKEN_LEGAL365 } })
        if (RES.status === 200) {
            dispatch({
                type: ADD_SUB_TASK,
                payload: { success: true, message: "Tarea Creada, espere...", status: 2, task: RES.data }
            })

        }
        else {
            dispatch({
                type: ADD_SUB_TASK,
                payload: { success: true, message: "Error al crear la tarea, res:" + RES.status, status: 3, task: {} }
            })
        }
    } catch (error) {
        dispatch({
            type: ADD_SUB_TASK,
            payload: { success: true, message: "Error al crear la tarea, res:" + error.response.status, status: 3, task: {} }
        })
    }
}

export const GetsubTask = () => async (dispatch, getState) => {
    const cookies = new Cookies()
    dispatch({
        type: GET_LISTA_SUB_TASK,
        payload: { success: false, message: "Buscando Lista de SubTareas, espere...", listSubTask: [], status: 1 }
    })

    try {
        const RES = await axios.get(TASK_V2_GETSUBTASK , { headers: { 'Authorization': `Bearer `+TOKEN_LEGAL365 } })

        if (RES.status === 200) {
            const data = RES.data

            dispatch({
                type: GET_LISTA_SUB_TASK,
                payload: { success: true, message: "Lista de SubTareas encontrada, espere...", listSubTask: data.listSubTask, status: 2 }
            })
        }
        else {
            dispatch({
                type: GET_LISTA_SUB_TASK,
                payload: { success: true, message: "Error al buscar la Lista de SubTareas res:" + RES.status, status: 3, listSubTask: [] }
            })
        }
    } catch (error) {
        dispatch({
            type: GET_LISTA_SUB_TASK,
            payload: { success: true, message: "Error al buscar la Lista de SubTareas res:" + error.response.status, status: 3, listSubTask: [] }
        })
    }
}

export const GetAccions = () => async (dispatch, getState) => {
    const cookies = new Cookies()

    dispatch({
        type: GET_LISTA_ACCIONES,
        payload: { success: false, message: "Buscando Lista de Acciones, espere...", list: [], status: 1 }
    })

    try {
        const RES = await axios.get(TASK_V2_GETACCIONS, { headers: { 'Authorization': `Bearer `+TOKEN_LEGAL365 } })

        if (RES.status === 200) {
            const data = RES.data

            dispatch({
                type: GET_LISTA_ACCIONES,
                payload: { success: true, message: "Lista de Acciones encontrada, espere...", list: data.listaAcciones, status: 2 }
            })
        }
        else {
            dispatch({
                type: GET_LISTA_ACCIONES,
                payload: { success: true, message: "Error al buscar la Lista de Acciones res:" + RES.status, status: 3, list: [] }
            })
        }
    } catch (error) {
        dispatch({
            type: GET_LISTA_ACCIONES,
            payload: { success: true, message: "Error al buscar la Lista de Acciones res:" + error.response.status, status: 3, list: [] }
        })
    }
}

export const GetDocuments = () => async (dispatch, getState) => {
    const cookies = new Cookies()

    dispatch({
        type: GET_LISTA_DOCUMENTS,
        payload: { success: false, message: "Buscando Lista de Documentos, espere...", list: [], status: 1 }
    })

    try {
        const RES = await axios.get(TASK_V2_GETDOCUMENTS + '?caseId=1', { headers: { 'Authorization': `Bearer `+TOKEN_LEGAL365 } })


        if (RES.status === 200) {
            const data = RES.data

            dispatch({
                type: GET_LISTA_DOCUMENTS,
                payload: { success: true, message: "Lista de Documentos encontrada, espere...", list: data, status: 2 }
            })
        }
        else {
            dispatch({
                type: GET_LISTA_DOCUMENTS,
                payload: { success: true, message: "Error al buscar la Lista de Documentos res:" + RES.status, status: 3, list: [] }
            })
        }
    } catch (error) {
        dispatch({
            type: GET_LISTA_DOCUMENTS,
            payload: { success: true, message: "Error al buscar la Lista de Documentos res:" + error.response.status, status: 3, list: [] }
        })
    }
}

export const CreateTemplate = (TEMPLATE) => async (dispatch, getState) => {
    const cookies = new Cookies()

    dispatch({
        type: CREATE_MEW_TEMPLATE,
        payload: { success: false, message: "Guardando Template, espere...", data: {}, status: 1 }
    })

    try {
        const RES = await axios.post(TASK_V2_CREATETEMPLATE, TEMPLATE, { headers: { 'Authorization': `Bearer `+TOKEN_LEGAL365 } })

        if (RES.status === 200) {
            const data = RES.data

            dispatch({
                type: CREATE_MEW_TEMPLATE,
                payload: { success: true, message: "Template almacenado, espere...", data: data, status: 4 }
            })
            setTimeout(() => {
                
                dispatch({
                    type: CREATE_MEW_TEMPLATE,
                    payload: {success: false, message: '', data:{} ,status: 0 }
                })
            }, 1000);
        }
        else {
            dispatch({
                type: CREATE_MEW_TEMPLATE,
                payload: { success: true, message: "Error al guardar el Template res:" + RES.status, status: 3, data: {} }
            })
        }
    } catch (error) {
        dispatch({
            type: CREATE_MEW_TEMPLATE,
            payload: { success: true, message: "Error al guardar el Template res:" + error.response.status, status: 3, data: {} }
        })
    }
}

export const GetTemplate = (data) => async (dispatch, getState) => {
    const cookies = new Cookies()

    dispatch({
        type: GET_TEMPLATE,
        payload: { success: false, message: "Buscando Template, espere...", data: {}, status: 1 }
    })

    try {
        const RES = await axios.post(TASK_V2_GETTEMPLATE, data, { headers: { 'Authorization': `Bearer `+TOKEN_LEGAL365 } })


        if (RES.status === 200) {
            const data = RES.data

            dispatch({
                type: GET_TEMPLATE,
                payload: { success: true, message: "Template encontrado", data: data, status: 2 }
            })
        }
        else {
            dispatch({
                type: GET_TEMPLATE,
                payload: { success: true, message: "Error al guardar el Template res:" + RES.status, status: 3, data: {} }
            })
        }
    } catch (error) {
        dispatch({
            type: GET_TEMPLATE,
            payload: { success: true, message: "Error al guardar el Template res:" + error.response.status, status: 3, data: {} }
        })
    }
}


export const GetWorkFlow = (data) => async (dispatch, getState) => {
    const cookies = new Cookies()

    dispatch({
        type: GET_TEMPLATE,
        payload: { success: false, message: "Buscando Template, espere...", data: {}, status: 1 }
    })

    try {
        const RES = await axios.post(TASK_V2_GET_WORKFLOW, data, { headers: { 'Authorization': `Bearer `+TOKEN_LEGAL365 } })


        if (RES.status === 200) {
            const data = RES.data

            dispatch({
                type: GET_TEMPLATE,
                payload: { success: true, message: "Template encontrado", data: data, status: 2 }
            })
        }
        else {
            dispatch({
                type: GET_TEMPLATE,
                payload: { success: true, message: "Error al guardar el Template res:" + RES.status, status: 3, data: {} }
            })
        }
    } catch (error) {
        dispatch({
            type: GET_TEMPLATE,
            payload: { success: true, message: "Error al guardar el Template res:" + error.response.status, status: 3, data: {} }
        })
    }
}

export const UpdateTemplate = (TEMPLATE) => async (dispatch, getState) => {
    const cookies = new Cookies()

    dispatch({
        type: CREATE_MEW_TEMPLATE,
        payload: { success: false, message: "Guardando Template, espere...", data: {}, status: 1 }
    })

    try {
        const RES = await axios.put(TASK_V2_UPDATETEMPLATE, TEMPLATE, { headers: { 'Authorization': `Bearer `+TOKEN_LEGAL365 } })
        
        if (RES.status === 200) {
            const data = RES.data

            dispatch({
                type: CREATE_MEW_TEMPLATE,
                payload: { success: true, message: "Template almacenado, espere...", data: data, status: 4 }
            })
        }
        else {
            dispatch({
                type: CREATE_MEW_TEMPLATE,
                payload: { success: true, message: "Error al guardar el Template res:" + RES.status, status: 3, data: {} }
            })
        }
    } catch (error) {
        dispatch({
            type: CREATE_MEW_TEMPLATE,
            payload: { success: true, message: "Error al guardar el Template res:" + error.response.status, status: 3, data: {} }
        })
    }
}


export const GetUsersCharge = () => async (dispatch, getState) => {
    const cookies = new Cookies()

    dispatch({
        type: GET_USERS_CHARGE,
        payload: { success: false, message: "buscando abogados, espere...", data: {}, status: 1 }
    })

    try {
        const RES = await axios.get(TASK_V2_GET_USERS_CHARGE, { headers: { 'Authorization': `Bearer `+TOKEN_LEGAL365 } })
        
        if (RES.status === 200) {
            const data = RES.data

            dispatch({
                type: GET_USERS_CHARGE,
                payload: { success: true, message: "abogados encontrados, espere...", data: data, status: 2 }
            })
        }
        else {
            dispatch({
                type: GET_USERS_CHARGE,
                payload: { success: true, message: "Error al buscar abogados: " + RES.status, status: 3, data: {} }
            })
        }
    } catch (error) {
        dispatch({
            type: GET_USERS_CHARGE,
            payload: { success: true, message: "Error al buscar abogados res:" + error.response.status, status: 3, data: {} }
        })
    }
}


export const GetUsersLegal = () => async (dispatch, getState) => {
    const cookies = new Cookies()

    dispatch({
        type: GET_LEGAL_ALL_USERS,
        payload: { success: false, message: "buscando usuarios legal, espere...", data: {}, status: 1 }
    })

    try {
        const RES = await axios.post(LEGAL_GET_ALL_USERS, null, { headers: { 'Authorization': `Bearer `+TOKEN_LEGAL365 } })
        
        if (RES.status === 200) {
            const data = RES.data

            dispatch({
                type: GET_LEGAL_ALL_USERS,
                payload: { success: true, message: "usuarios legal encontrados, espere...", data: data, status: 2 }
            })
        }
        else {
            dispatch({
                type: GET_LEGAL_ALL_USERS,
                payload: { success: true, message: "Error al buscar usuarios legal: " + RES.status, status: 3, data: {} }
            })
        }
    } catch (error) {
        dispatch({
            type: GET_LEGAL_ALL_USERS,
            payload: { success: true, message: "Error al buscar usuarios legal res:" + error.response.status, status: 3, data: {} }
        })
    }
}



export const ClearTemplate = (data) => async (dispatch, getState) => {
    dispatch({
        type: GET_LISTA_SUB_TASK,
        payload: { success: false, message: '', listSubTask: [], status: 0 }
    })
    dispatch({
        type: GET_LISTA_ACCIONES,
        payload: { success: false, message: '', list: [], status: 0 },
    })

    dispatch({
        type: GET_LISTA_DOCUMENTS,
        payload: { success: false, message: '', list: [], status: 0 }
    })

    dispatch({
        type: ADD_SUB_TASK,
        payload: { success: false, message: '', task: {}, status: 0 }
    })

    dispatch({
        type: GET_TEMPLATE,
        payload: {success: false, message: '', data:{
            groupId: 0,
            serviceId: 0,
            listOfTasks: [
                {
                    orden: 0,
                    nomencltureId: 0,
                    descripcion: '',
                    subTareas: [
                        {
                            orden: 0,
                            idSubTask: 0,
                            titulo: '',
                            descripcion: '',
                            acciones: [
                                {
                                    id: 0,
                                    dias: 0,
                                    documento: 0,
                                    subTarea: 0,
                                    nomenclatura: 0
                                }
                            ],
                            '': [
                                0
                            ]
                        }
                    ]
                }
            ]
        } ,status:0},
    })

    dispatch({
        type: CREATE_MEW_TEMPLATE,
        payload: {success: false, message: '', data:{} ,status:0}
    })
}

/*

export const GetNomenclatures = () => async (dispatch, getState) => {
TASK_V2_GETNOMENCLATURES
}

export const GetTemplate = () => async (dispatch, getState) => {
TASK_V2_GETTEMPLATE
}



/*
dispatch({
        type: GET_INFO,
        payload: { success: false, message: "Buscando Información de Tareas, espere...", status: 1 }
    })

    try {
        const RES = await axios.get(TASK_V2_GETINFO)

        if (RES.status === 200) {
            const data = RES.data

            dispatch({
                type: GET_INFO,
                payload: { success: true, message: "Información encontrada, espere...", status: 2 }
            })


            

                    
        }
        else {
            dispatch({
                type: GET_INFO,
                payload: { success: true, message: "Error al buscar la informacion res:"+RES.status, status: 3 }
            })
        }
    } catch (error) {
        dispatch({
            type: GET_INFO,
            payload: { success: true, message: "Error al buscar la informacion res:"+error.response.status, status: 3 }
        })
    }
*/